import { NavLink, useLocation } from "react-router";
import "../style/admin-subheader.css";

export function AdminSubheader({
	items,
	preserveSearchParams = false,
}: {
	items: {
		label: string;
		link: string;
	}[];
	preserveSearchParams?: boolean;
}) {
	const location = useLocation();
	const search = preserveSearchParams ? location.search : "";

	return (
		<div className="admin-subheader">
			{items.map((item, index) => (
				<NavLink to={`${item.link}${search}`} className="admin-subheader__tab" key={`tab-${index}`}>
					{item.label}
				</NavLink>
			))}
		</div>
	);
}
